













import HashTagItem from "../molecules/HashTagItem.vue";
import AddIcon from "../../assets/icons/Orion_add-circle.svg";
import { Hashtag } from "../../components/molecules/HashTagItem.vue";
import Vue, { PropType } from "vue";
type Data = {
  hashtagItems: Hashtag[];
};

export default Vue.extend({
  components: {
    HashTagItem,
    AddIcon
  },
  props: {
    hashtags: {
      type: Array as PropType<Hashtag[]>,
      default: () => []
    }
  },
  data(): Data {
    return {
      hashtagItems: this.hashtags
    };
  },
  methods: {
    onChangeHashtagList(hashtagItem: Hashtag, index: number): void {
      this.hashtagItems[index] = hashtagItem;
      this.$emit("on-change-hashtag-list", this.hashtagItems);
    },
    deleteListItem(index: number): void {
      this.$emit("delete-list-item", { item: "hashtags", index: index });
    },
    addListItem(): void {
      this.$emit("add-list-item", { item: "hashtags" });
    }
  }
});
